import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ProfileMenu from './ProfileMenu';
import Util from 'utility';
import { __ } from 'locale';

function Header() {
    const data = useSelector(state => state);
    const history = useHistory();
    const location = useLocation();

    const goToPlan = (e) => {
        const url = location.pathname;
        if (url.substr(0, 18) == '/recipe/edit/meal/') {
            if (window.confirm('Chcete opustit tuto stránku?')) {
                history.push('/plan');
            } else {
                e.preventDefault();
            }
        } else {
            history.push('/plan');
        }
    };

    let active = 'home';
    ['plan', 'recipe'].forEach(link => {
        if (location.pathname.match('/' + link)) active = link;
    });

    let taskTitle = 'Úkol';
    if (Util.getLang() == 'sk') taskTitle = 'Úloha';

    const seminarWorkData = data.appModeData?.lectureInfoData?.seminar_work_data;
    const isSeminarWorkMode = typeof seminarWorkData === 'object';
    if (isSeminarWorkMode) {
        taskTitle = Util.getLectureTaskDishTerm(data.appModeData?.lectureInfoData, 'nom', true);
    }

    const hiddenNavItem = isSeminarWorkMode ? ' invisible pointer-events-none' : '';
    const navBase = 'inline-block py-[1em] px-[0.35em] text-center no-underline relative text-[#253551] mx-2 border-t-[3px] border-t-white border-b-[3px] border-solid';
    const navActive = `${navBase} !border-b-[#253551] font-bold`;
    const navInactive = `${navBase} border-b-white hover:border-b-[#ccc]`;

    return (
        <header className="bg-white border-b border-[#ebebeb] relative">
            <div className="max-w-[1180px] mx-auto px-[1em] flex items-center">
                <span className="relative top-[2px] no-underline font-black italic text-[15px] leading-[90%] text-[#26AA52]">
                    <b className="text-[#444]">ZOF</b><br />APP
                </span>
                <input type="checkbox" id="cb-nav" className="hidden" />
                <label htmlFor="cb-nav" className="hidden"><i className="fa fa-bars"></i> Menu</label>
                <nav className="flex-1 flex items-end self-end justify-center pl-[2em] text-[0.85em]">
                    <label htmlFor="cb-nav" className="hidden"><i className="fa fa-times"></i></label>
                    <a
                        onClick={(e) => goToPlan(e)}
                        className={(active === 'plan' ? navActive : navInactive) + hiddenNavItem}
                        title="Úkol"
                        aria-hidden={isSeminarWorkMode}
                        tabIndex={isSeminarWorkMode ? -1 : undefined}
                    >
                        {taskTitle}
                    </a>
                    <Link
                        className={(active === 'recipe' ? navActive : navInactive) + hiddenNavItem}
                        to="/recipe"
                        title="Recepty"
                        aria-hidden={isSeminarWorkMode}
                        tabIndex={isSeminarWorkMode ? -1 : undefined}
                    >
                        Recepty
                    </Link>
                </nav>
                <aside className="text-white self-center flex items-center ml-auto">
                    <ProfileMenu />
                </aside>
                <div className="hidden"></div>
            </div>
        </header>
    );
}

export default Header;
